import { ReactNode } from 'react';
import { Divider } from 'primereact/divider';
import { Tooltip } from 'primereact/tooltip';

interface LedgerFormulaTooltipProps {
    target: string;
    title: string;
    children: ReactNode;
    finalLine: ReactNode;
    disabled?: boolean;
    onBeforeHide?: () => void;
}

export default function LedgerFormulaTooltip({
    target,
    title,
    children,
    finalLine,
    disabled = false,
    onBeforeHide,
}: LedgerFormulaTooltipProps) {
    return (
        <Tooltip
            target={target}
            position='top'
            className="ledger-formula-tooltip-ui"
            disabled={disabled}
            onBeforeHide={onBeforeHide}
        >
            <div className="ledger-formula-tooltip-ui__wrap">
                <div className="ledger-formula-tooltip-ui__row ledger-formula-tooltip-ui__row--title fw-bold">
                    <h5 className='fw-bold mb-0'>{title}</h5>
                </div>
                <Divider />
                <div className="ledger-formula-tooltip-ui__body">
                    {children}
                </div>
                <Divider />
                <div className="ledger-formula-tooltip-ui__row ledger-formula-tooltip-ui__row--final fw-bold mb-0">
                    {finalLine}
                </div>
            </div>
        </Tooltip>
    );
}
